import React, { useState } from 'react'
import { Container, Dropdown, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { checkTwilioIntegration, getCountryCode, maskContactNumber, navigateToCrmDetail } from '../../../Utils/helpers/commonhelper';
import useLocalStorageState from 'use-local-storage-state';
import { useLocation } from 'react-router-dom';
// import Tooltip from '@mui/material/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical, faPhone } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'sonner';
import GlobalCallModal from '../../ivr/GlobalCallModal';
import TwilioIntegrationForm from '../../ivr/TwilioIntegrationForm';
import { CButton, CPopover } from '@coreui/react';
import { TableWrapper } from '../../../CommonComponents/TableWrapper';
import { ContactTooltip } from '../../Contacts/ContactModule/ContactTooltip';
import { IconPhone } from '@tabler/icons-react';
import { useGetEssentials } from '../../../Utils/hooks/useGetEssentials';

export const CompanyTableListing = ({
    isLoading,
    highlightId,
    dataToDisplay,
    hasDataToDisplay,
    columnOptions,
    columns,
    limit,
    setLimit,
    activeOffset,
    setActiveOffset,
    effectivePageCount,
    totalItems,
    displayStartItem,
    displayEndItem,
    handlePageChange,
    fetchCompanyDetails,
    setConfirmDeleteId,
}) => {

    const { customer, setCustomer, headers, extras, navigate, customerId: customer_id, loginUserId, userType } = useGetEssentials()
    const location = useLocation()
    // rbac permission object 
    const [PERMISSION] = useLocalStorageState('permission')
    // company rbac permission
    const companyGrants = PERMISSION?.company

    const currPageItems = dataToDisplay?.length;
    const [openRow, setOpenRow] = useState(null)

    // dialler states for twilio
    const [isCheckingTwilio, setIsCheckingTwilio] = useState(false);
    const [globalDiller, setGlobalDiller] = useState(false);
    const [showtwilioModal, setShowTwilioModal] = useState(false);
    const [module_id, setModuleId] = useState(null);
    const [callingTo, setCallingTo] = useState(null)

    const checkTwilio = async () => {
        if (isCheckingTwilio) return;
        setIsCheckingTwilio(true);
        try {
            const res = await checkTwilioIntegration(customer_id, headers, extras)
            if (res.status === "fail" || res.success === false) {
                setShowTwilioModal(true);
            }
            if (res.status === "success") {
                setGlobalDiller(true);
            }

        } catch (error) {
            console.error(error)
        } finally {
            setIsCheckingTwilio(false);
        }
    }

    // for calling
    const handleGlobalCallChange = () => {
        setGlobalDiller(false);
        setModuleId(null)
        setCallingTo(null)
    };

    // Helper functions for column filtering
    const getColumnData = (company, columnId, index) => {
        const columnMap = {
            "#": index + 1 + activeOffset * limit,
            name: company.company_name || "-",
            website: company.website || "-",
            industry: company.industry || "-",
            business_type: company.business_type || "-",
            owner: company.owner_name || "-",
            email: company.email || "-",
            address: company.address || "-",
            state: company.state_name || "-",
            city: company.city_name !== null ? company.city_name : "-",
            zipcode: company.zipcode || "-",
        }
        return columnMap[columnId] || "-"
    }

    const getColumnStyle = (columnId) => {
        switch (columnId) {
            case "name":
                return { fontWeight: 600, color: "inherit" }
            case "email":
                return { color: "#2184ff" }
            case "industry":
                return { color: "#2184ff" }
            case "phone":
                return { color: "#2184ff" };
            default:
                return {}
        }
    }

    const ownerColorMap = {}

    const getColumnContent = (company, columnId, index) => {
        const data = getColumnData(company, columnId, index)
        const tooltip = <Tooltip id="tooltip">{company?.website ?? "-"}</Tooltip>

        const tooltips = <Tooltip id="tooltip">{data}</Tooltip>
        const addressTooltip = <Tooltip id="tooltip">{data}</Tooltip>

        switch (columnId) {
            case "name":
                return (
                    <div className="d-flex align-items-center gap-1">
                        {company?.website !== null ? (
                            <a
                                href={
                                    company?.website ??
                                    (company?.website?.startsWith("http")
                                        ? company?.website
                                        : `https://${company?.website}`)
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                className="me-2"
                            >
                                <OverlayTrigger placement="top" overlay={tooltip}>
                                    <i className="bi bi-globe"></i>
                                </OverlayTrigger>
                            </a>
                        ) : (
                            <i
                                className="bi bi-globe me-2"
                                style={{ color: "#4b4f56b8" }}
                            ></i>
                        )}

                        <div
                            onClick={(e) => {
                                e.preventDefault()
                                navigateToCrmDetail(
                                    navigate,
                                    location,
                                    `/companyDetails?currCompanyId=${company.id}`,
                                    {
                                        companyIds: dataToDisplay.map(({ id }) => id),
                                    },
                                )
                            }}
                            style={{ color: "inherit", textDecoration: "none", cursor: "pointer" }}
                        >
                            {data?.length > 30 ? (
                                <OverlayTrigger placement="top" overlay={tooltips}>
                                    <span>{`${data.slice(0, 20)}...`}</span>
                                </OverlayTrigger>
                            ) : (
                                data
                            )}
                        </div>
                    </div>
                )
            case "email":
                return company.email ? (
                    <a href={`mailto:${company.email}`}>
                        <i className="fa-solid fa-envelope me-1"></i> {company.email}
                    </a>
                ) : (
                    "-"
                )
            case "phone": {
                const phoneArray = company?.user_phone
                    ? JSON.parse(company.user_phone)
                    : [];
                const firstEntry = phoneArray[0];
                return firstEntry?.phone ? (
                    <span
                        style={{
                            cursor: 'pointer',
                            color: "#2184ff",
                            fontFamily: "monospace",
                            letterSpacing: "1px",
                            whiteSpace: "nowrap",
                        }}
                        disabled={isCheckingTwilio}
                        onClick={() => {
                            !showtwilioModal && setModuleId(company?.id)
                            setCallingTo(`${firstEntry?.country_code} ${firstEntry?.phone}`)
                            checkTwilio()
                        }}
                    > <IconPhone size={14} stroke={2.5} style={{ color: 'blue' }} />{`${firstEntry?.country_code} ${maskContactNumber(customer, firstEntry?.phone)}`}</span>
                ) : (
                    "-"
                );
            }
            case "industry":
                return company.industry ? (
                    <ContactTooltip
                        contact={company}
                        data={company?.phone}
                        customer={customer}
                        module_name={"company"}
                    />
                ) : (
                    "-"
                )
            case "owner": {
                const getRandomColor = () => {
                    const hue = Math.floor(Math.random() * 360)
                    const saturation = 45 + Math.random() * 10
                    const lightness = 70 + Math.random() * 10
                    return `hsl(${hue}, ${saturation}%, ${lightness}%)`
                }

                const getColorForOwner = (name) => {
                    if (!name) return "#d6d6d6"

                    if (ownerColorMap[name]) return ownerColorMap[name]

                    let newColor
                    do {
                        newColor = getRandomColor()
                    } while (Object.values(ownerColorMap).includes(newColor))

                    ownerColorMap[name] = newColor
                    return newColor
                }

                const pillColor = getColorForOwner(company.owner_name)

                return (
                    <span
                        style={{
                            display: "inline-block",
                            backgroundColor: pillColor,
                            color: "#3f3d3d",
                            padding: "1px 8px 2px",

                            borderRadius: "20px",
                            fontSize: "11px",
                            fontWeight: "400",
                            textTransform: "capitalize",
                        }}
                    >
                        {company.owner_name || "N/A"}
                    </span>
                )
            }
            case "address": {
                return (
                    <>
                        <OverlayTrigger placement="top" overlay={addressTooltip}>
                            <span>
                                {company.address?.length > 20
                                    ? `${company?.address.slice(0, 20)}...`
                                    : company.address}
                            </span>
                        </OverlayTrigger>
                    </>
                )
            }

            default:
                return data
        }
    }

    const renderTableHeaders = () => {
        return (
            <thead style={{ zIndex: 10 }}>
                <tr style={{ textAlign: "start" }}>
                    <th>#</th>
                    {columns.map((columnLabel) => {
                        return (
                            <React.Fragment key={columnLabel}>
                                <th >
                                    {columnLabel}{" "}
                                    <i className="fa-solid fa-sort" />
                                </th>
                            </React.Fragment>
                        )
                    })}
                    <th
                        className="lastactionTd"
                        id="lastactionTh"
                        style={styles.lastdStyle}
                    ></th>
                </tr>
            </thead>
        );
    };

    const renderTableBody = () => (dataToDisplay?.map((company, index) => {
        return (
            <tr
                key={company.id}
                style={{ marginTop: "10px", marginBottom: "10px" }}
                className={String(company.id) === String(highlightId) ? "blink-row" : ""}
            >
                <td>{index + 1 + limit * activeOffset}</td>
                {columns?.map((label) => {
                    const col = columnOptions.find(c => c.label === label);
                    if (!col) return null;

                    return (
                        <td key={col.id} style={getColumnStyle(col.id)}>
                            {getColumnContent(company, col.id, index)}
                        </td>
                    );
                })}
                <td
                    className="lastactionTd"
                    style={{
                        ...styles.lastdStyle,
                        zIndex: openRow === company.id ? 11 : "auto",
                    }}
                >
                    <div className="endTdDiv">
                        <Dropdown
                            as="div"
                            className="dropdownsWithoutToggle"
                            onToggle={(isOpen) =>
                                setOpenRow(isOpen ? company.id : null)
                            }
                        >
                            <Dropdown.Toggle as={Nav.Link} className="header-link">
                                <FontAwesomeIcon
                                    icon={faEllipsisVertical}
                                    style={{
                                        fontSize: "15px",
                                        width: "20px",
                                        color: "#536485",
                                    }}
                                />
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                                align={"end"}
                                style={{
                                    width: "8rem",
                                    inset: "0px auto auto 0px",
                                    boxShadow: "rgb(215, 215, 215) 0px 0px 15px",
                                    position: "absolute",
                                    marginTop: "-22px",
                                    marginRight: "40px",
                                    minWidth: "3rem",
                                }}
                            >
                                <Dropdown.Item
                                    style={{
                                        fontSize: "12px",
                                        padding: "4px 21px",
                                    }}
                                    className="d-flex align-items-center btn"
                                    onClick={() => {
                                        if (!companyGrants.isEdit) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                        }
                                        console.log("calling company fetch")
                                        fetchCompanyDetails(company.id)
                                    }
                                    }
                                >
                                    {" "}
                                    Edit{" "}
                                </Dropdown.Item>
                                <Dropdown.Item
                                    style={{
                                        fontSize: "12px",
                                        padding: "4px 21px",
                                    }}
                                    className="d-flex align-items-center btn"
                                    onClick={() => {
                                        if (!companyGrants.isDelete) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                        }
                                        setConfirmDeleteId(company.id)
                                    }
                                    }
                                >
                                    {" "}
                                    Delete{" "}
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </td>
            </tr>
        )
    }))

    return (
        <>
            <Container
                fluid
                style={{
                    fontFamily: "'Poppins', sans-serif",
                    height: "calc(100vh - 10rem)",
                    padding: 0,
                    animation: "cardEntry 1s ease-out forwards",
                }}
                className="mt-3 p-0"
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        width: "100%",
                        borderRadius: "7px"
                    }}
                    className='position-relative container-table '
                >
                    <TableWrapper
                        isLoading={isLoading}
                        hasData={hasDataToDisplay}
                        tableHeader={renderTableHeaders()}
                        tableBody={renderTableBody()}
                        displayStartItem={displayStartItem}
                        displayEndItem={displayEndItem}
                        totalItems={totalItems}
                        currPageItems={currPageItems}
                        offset={activeOffset}
                        setOffset={setActiveOffset}
                        limit={limit}
                        setLimit={setLimit}
                        handlePageChange={handlePageChange}
                        effectivePageCount={effectivePageCount}
                        columnLabels={columns}
                    />
                </div>
            </Container>
            {globalDiller && (
                <GlobalCallModal
                    isOpen={globalDiller}
                    customerId={customer_id}
                    loginUserId={loginUserId}
                    phoneNumber={callingTo}
                    onClose={handleGlobalCallChange}
                    module_name={"company"}
                    module_id={module_id}
                />
            )}


            {/* {twilio modal} */}
            {showtwilioModal && (
                <TwilioIntegrationForm
                    isOpen={showtwilioModal}
                    onClose={() => setShowTwilioModal(false)}
                />
            )}

        </>
    )
}

const styles = {
    lastdStyle: {
        padding: "0 !important",
    }
}
